import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import 'leaflet/dist/leaflet.css';
import { App } from './app/App';
import './index.css';
import { store } from './app/store';
import { setupApiInterceptors } from './lib/api';
import { queryClient } from './lib/queryClient';
import { AppErrorBoundary } from './components/ui/AppErrorBoundary';
setupApiInterceptors(store);
ReactDOM.createRoot(document.getElementById('root')).render(_jsx(React.StrictMode, { children: _jsx(AppErrorBoundary, { children: _jsx(Provider, { store: store, children: _jsx(QueryClientProvider, { client: queryClient, children: _jsx(BrowserRouter, { children: _jsx(App, {}) }) }) }) }) }));
